import Home from '@/components/page/Home';
import Events from '@/components/page/Events';
import Universes from '@/components/page/Universes';
import Feeds from '@/components/page/Feeds';
import FeedResources from '@/components/page/FeedResources/';
import Takers from '@/components/page/Takers';
import Entities from '@/components/page/Entities';
import RightGroup from '@/components/page/RightGroup';
import Consumption from '@/components/page/Consumption';
import Mismatch from '@/components/page/Mismatches';
import Monitoring from '@/components/page/Monitoring';
import Ird from '@/components/page/Receiver';
import AdminNotification from '@/components/page/ManageAlarmAlertNotification';
import Channels from '@/components/page/Channels';
import ChannelsOverview from '@/components/page/ChannelsOverview';
import FeedResourcesOverview from '@/components/page/FeedResourcesOverview';
import Setting from '@/components/page/Setting';
// Routes
const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Home
    },
    {
        path: '/universes',
        name: 'universes',
        component: Universes
    },
    {
        path: '/events/:eventUid?/:edit?',
        name: 'events',
        component: Events
    },
    {
        path: '/feed-resources/:feedResourceUid?/:edit?',
        name: 'feed-resources',
        component: FeedResources
    },
    {
        path: '/feed-resources-overview',
        name: 'feed-resources-overview',
        component: FeedResourcesOverview
    },
    {
        path: '/feeds/:feedUid?/:edit?',
        name: 'feeds',
        component: Feeds
    },
    {
        path: '/takers/:takerUid?/:edit?',
        name: 'takers',
        component: Takers
    },
    {
        path: '/entities/:entityUid?',
        name: 'entities',
        component: Entities
    },
    {
        path: '/right-group',
        name: 'right-group',
        component: RightGroup
    },
    {
        path: '/consumption',
        name: 'consumption',
        component: Consumption,
    },
    {
        path: '/booking-mismatch',
        name: 'booking-mismatch',
        component: Mismatch,
    },
    {
        path: '/monitoring',
        name: 'monitoring',
        component: Monitoring
    },
    {
        path: '/admin-notification',
        name: 'admin-notification',
        component: AdminNotification
    },
    {
        path: '/receivers',
        name: 'receivers',
        component: Ird
    },
    {   path: '/channels',
        name: 'channels',
        component: Channels
    },
    {   path: '/channels-overview',
        name: 'channels-overview',
        component: ChannelsOverview
    },
    {
        path: '/settings',
        name: 'settings',
        component: Setting
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js